import { pick } from 'lodash'
import { track } from './analytics'

export const gateViewed = args => {
  track('Gate Viewed', pick(args, ['workspaceId', 'workspaceSlug', 'feature']))
}

export const demoRequested = args => {
  track(
    'Demo Requested',
    pick(args, ['workspaceId', 'workspaceSlug', 'feature', 'userEmail'])
  )
}
